import { MutableRefObject } from 'react';
import { SearchCollectionName } from 'api/search';
import { createWithEqualityFn as create } from 'zustand/traditional';

interface SearchStore {
    isOpen: boolean;
    setIsOpen: (isOpen: boolean) => void;
    query: string;
    setQuery: (query: string) => void;
    resourceFilter: SearchCollectionName[];
    setResourceFilter: (resources: SearchCollectionName[]) => void;
    addResourceFilter: (resource: SearchCollectionName) => void;
    removeResourceFilter: (resource: SearchCollectionName) => void;
    searchRef: MutableRefObject<HTMLInputElement | null>;
    listRef: MutableRefObject<HTMLDivElement | null>;
    isTypesensePending: boolean;
    setIsTypesensePending: (isPending: boolean) => void;
    clear: () => void;
}

const useSearchStore = create<SearchStore>(set => ({
    query: '',
    setQuery: query => set({ query }),
    isOpen: false,
    setIsOpen: isOpen => set({ isOpen }),
    resourceFilter: [],
    setResourceFilter: resources => set({ resourceFilter: resources }),
    addResourceFilter: resource =>
        set(state => ({ resourceFilter: [...state.resourceFilter, resource] })),
    removeResourceFilter: resource =>
        set(state => {
            const index = state.resourceFilter.indexOf(resource);
            return { resourceFilter: state.resourceFilter.toSpliced(index, 1) };
        }),
    searchRef: { current: null },
    listRef: { current: null },
    isTypesensePending: false,
    setIsTypesensePending: isTypesensePending => set({ isTypesensePending }),
    clear: () =>
        set({
            query: '',
            resourceFilter: [],
        }),
}));

export { useSearchStore };
export type { SearchStore };
